import { render, staticRenderFns } from "./KillSelfSabotageSetup.vue?vue&type=template&id=35d0b792&scoped=true&"
import script from "./KillSelfSabotageSetup.vue?vue&type=script&lang=js&"
export * from "./KillSelfSabotageSetup.vue?vue&type=script&lang=js&"
import style0 from "./KillSelfSabotageSetup.vue?vue&type=style&index=0&id=35d0b792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0b792",
  null
  
)

export default component.exports